import deviceHelper from "@/utils/deviceInfo";

export default function useResizeWebviewWithSafeArea(
  withSafeArea: boolean,
  delayMillis?: number
): void {
  if (deviceHelper.isAndroid()) {
    window.android.resizeWebviewWithSafeArea(withSafeArea, delayMillis ?? 0);
  } else if (deviceHelper.isiOS()) {
    window.webkit.messageHandlers.resizeWebviewWithSafeArea.postMessage(
      withSafeArea ? "true" : "false"
    );
  }
}
